import * as constants from "../constants/constants";
import { Responsibility } from '../types/responsibility.type';

export interface ProductionState {
    responsibilities: Responsibility[],
    userResponsibilities: Responsibility[],
    productionTableData: any//make type
    productStatuses: any//make type
    productPrices: any//make type
    productPricesPagination: any
    productPricesTotalPrice: number
    warehouseProducts: any//make type
    warehouseProductsTotalPrice: number
    blueprintFiles: any//make type
    selectedTrack: any
    materialsOfProduct: any
    passiveProducts: any
    passiveProductsPagination: any
}

const initialState = () => {
    return {
        responsibilities: [],
        userResponsibilities: [],
        productionTableData: [],
        productStatuses: [],
        productPrices: [],
        productPricesPagination: { currentPage: 1, lastPage: 1, perPage: 20, total: 0 },
        productPricesTotalPrice: 0,
        warehouseProducts: [],
        warehouseProductsTotalPrice: 0,
        blueprintFiles: [],
        selectedTrack: null,
        materialsOfProduct: [],
        passiveProducts: [],
        passiveProductsPagination: { currentPage: 1, lastPage: 1, perPage: 20, total: 0 }
    }
}

const production = (state: ProductionState = initialState(), action: any) => {
    switch (action.type) {
        case constants.FETCH_RESPONSIBILITIES: {
            return { 
                ...state, 
                responsibilities: action.payload
            };
        }
        case constants.FETCH_USER_RESPONSIBILITIES: {
            return { 
                ...state, 
                userResponsibilities: action.payload
            };
        }
        case constants.FETCH_PRODUCTION_TABLE_DATA: {
            return { 
                ...state, 
                productionTableData: action.payload.data
            };
        }
        case constants.FETCH_PRODUCT_STATUSES: {
            return {
                ...state,
                productStatuses: action.payload.data
            };
        }
        case constants.FETCH_PRODUCT_PRICES: {
            return {
                ...state,
                productPrices: action.payload.data,
                productPricesTotalPrice: action.payload.totalPrice || 0,
                productPricesPagination: {
                    currentPage: action.payload.meta?.current_page || 1,
                    lastPage: action.payload.meta?.last_page || 1,
                    perPage: action.payload.meta?.per_page || 20,
                    total: action.payload.meta?.total || 0
                }
            };
        }
        case constants.FETCH_PASSIVE_PRODUCTS: {
            // Map Laravel pagination format (snake_case) to component format (camelCase)
            const paginationMapped = action?.payload?.meta || action?.payload ? {
                currentPage: action.payload.meta?.current_page || action.payload.current_page || 1,
                lastPage: action.payload.meta?.last_page || action.payload.last_page || 1,
                perPage: action.payload.meta?.per_page || action.payload.per_page || 20,
                total: action.payload.meta?.total || action.payload.total || 0
            } : null;

            return {
                ...state,
                passiveProducts: action.payload.data,
                passiveProductsPagination: paginationMapped
            };
        }
        case constants.FETCH_WAREHOUSE: {
            return {
                ...state,
                warehouseProducts: action.payload.data,
                warehouseProductsTotalPrice: action.payload.totalPrice || 0,
                warehouseProductsPagination: {
                    currentPage: action.payload.meta?.current_page || action.payload.current_page || 1,
                    lastPage: action.payload.meta?.last_page || action.payload.last_page || 1,
                    perPage: action.payload.meta?.per_page || action.payload.per_page || 20,
                    total: action.payload.meta?.total || action.payload.total || 0
                }
            };
        }
        case constants.GET_MATERIALS_FOR_PRODUCTS_AND_RESPONSIBILITY: {
            return {
                ...state,
                productMaterials: action.payload.data
            }
        }
        case constants.GET_BLUEPRINT_FILES: {
            return {
                ...state,
                blueprintFiles: action.payload?.data
            }
        }
        case constants.GET_CURRENT_RESPONSIBILITY_TIME: {
            return {
                ...state,
                selectedTrack: action.payload
            }
        }
        case constants.GET_MATERIALS_OF_PRODUCT: {
            return {
                ...state,
                materialsOfProduct: action.payload
            }
        }
    }
    return state;
}

export default production;